/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Table_TotalInputs */

const en_common_table_total = /** @type {(inputs: Common_Table_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} records`)
};

const zh_common_table_total = /** @type {(inputs: Common_Table_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 条记录`)
};

/**
* | output |
* | --- |
* | "{count} records" |
*
* @param {Common_Table_TotalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_table_total = /** @type {((inputs: Common_Table_TotalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Table_TotalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_table_total(inputs)
	return zh_common_table_total(inputs)
});
export { common_table_total as "common.table.total" }